import type { FaireProductEntity } from "../../entity_types/product";

export const p_8j6xsns3nv: FaireProductEntity = {
  token: "p_8j6xsns3nv",
  type: "product",
  name: "Mahjong Tea Towel | Ladies Game Night Decor | Mahjong Gifts",
  brandToken: "b_wws7d39tvc",
  brandName: "Madison’s Pop Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/56f0b96831d44b974c0920f574702f4151371555828b1a7c9b6267bab94fc368.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa4320c8e64917591619cb2d2869b45148f25f4d9b8b74565af9402e0d3e8a97.png",
    "https://cdn.faire.com/fastly/d5d05cbdb63bccccfe94d7d04adab2058a82470fb8e3494aa99ba52d7ebb2c90.png",
    "https://cdn.faire.com/fastly/92802058cc2472ab28e6c1a4aa1b40e74cdf8011e7a3e92c7f92123f1dd99b0a.jpeg",
    "https://cdn.faire.com/fastly/bb152300040634db4fc4a9c3e4de36600704fce7a3db34413fe2095cab2de296.jpeg",
  ],
  priceDollars: 6,
  description:
    "\nBring a little joy (and a lot of laughs!) into your kitchen with this charming and playful tea towel designed for mahjong lovers everywhere!\n\nFeaturing the phrase “Happiness is playing Mahjong with the girls”, this towel celebrates friendship, fun, and your favorite game night tradition. With its clean, classic design and subtle mahjong tile accents, it’s the perfect mix of stylish and sentimental.\n\nWhether you’re hosting mahjong night, gifting your favorite game partner, or adding personality to your kitchen, this towel is a must-have for anyone who loves time around the table.\n\n⸻\n\n💖 WHY YOU’LL LOVE IT\n\n* Perfect for mahjong lovers and game night enthusiasts\n* Thoughtful and unique gift idea\n* Clean, stylish design that fits any kitchen\n* A fun way to celebrate friendship and tradition\n\n⸻\n\n🎁 PERFECT FOR\n\n* Mahjong night host gifts\n* Birthday gifts for friends\n* Holiday gifts\n* Mother’s Day gifts\n* Game lovers & social groups\n* Retirement gifts (huge market for mahjong 👀)\n\n⸻\n\n📏 PRODUCT DETAILS\n\n* Soft, durable kitchen/tea towel\n* High-quality printed design\n* Great for everyday use or display\n* Lightweight and easy to care for\n* 💯 Cotton\n* 28” x 28”\n\n\n\n⸻\n\n🧼 CARE INSTRUCTIONS\n\n* Machine wash cold\n* Tumble dry low\n* Do not bleach\n\n⸻\n\n📦 SHIPPING\n\n* Carefully made and packaged\n* Ready for gifting\n* Fast processing",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:49.946Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
